import React from 'react';
import HistoryStatsCards from './history-stats-cards';
import { IHistorischeStatistieken } from '../models/page';

export interface IGoudenTableProps {
	results: IHistorischeStatistieken;
}

export default function GoudenSchildTable({ results }: IGoudenTableProps) {
	return (
		<>
			<HistoryStatsCards schilden={results.goudenSchilden.schilden} defaultOpen={false} />
		</>
	);
}
